"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    pictureWrapper: {
      zoom: 1,
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.NEUTRAL010,
      border: "1px dashed ".concat(theme.palette.NEUTRAL200),
      borderRadius: 4,
      cursor: 'pointer',
      '&:hover': {
        borderColor: theme.palette.BLUE400
      }
    },
    pictureDropzone: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(1),
      height: '100%',
      width: '100%'
    },
    uploadText: {
      color: theme.palette.NEUTRAL200,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
      textAlign: 'center'
    },
    iconAttachment: {
      fontSize: theme.typography.pxToRem(19)
    },
    listItem: {
      width: '100%',
      height: '100%',
      display: 'flex',
      padding: theme.spacing(0.5),
      margin: theme.spacing(1, 0),
      position: 'relative',
      '&:hover': {
        backgroundColor: theme.palette.NEUTRAL020
      }
    },
    listItemName: {
      flex: '1 1 auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: theme.palette.NEUTRAL200,
      paddingLeft: theme.spacing(1.5)
    },
    listItemActions: {
      flex: '0 0 auto',
      opacity: 1
    },
    actionButton: {
      padding: 0,
      fontSize: theme.typography.pxToRem(19),
      margin: theme.spacing(0, 1),
      color: theme.palette.NEUTRAL200,
      transition: 'color 0.2s ease',
      '&:hover, &:focus': {
        color: theme.palette.NEUTRAL400
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;